import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 0,
  class: "photo-title-badge photo-tile-badge"
}
const _hoisted_4 = ["checked"]
const _hoisted_5 = {
  key: 2,
  class: "photo-tile-busy"
}
const _hoisted_6 = { class: "card-body p-2" }
const _hoisted_7 = {
  key: 0,
  class: "photo-tile-description"
}
const _hoisted_8 = { class: "d-flex align-items-center mt-1" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "dropdown" }
const _hoisted_12 = { class: "dropdown-menu dropdown-menu-end shadow-sm" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card shadow-sm h-100 photo-tile", {'photo-tile-selected': _ctx.selected}])
  }, [
    _createElementVNode("div", {
      class: "photo-tile-thumb",
      title: _ctx.selecting ? 'Vybrat' : 'Zvětšit',
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(_ctx.selecting ? 'toggle-selected' : 'open')))
    }, [
      _createElementVNode("img", {
        src: _ctx.url,
        alt: _ctx.photo.description,
        loading: "lazy"
      }, null, 8, _hoisted_2),
      (_ctx.isTitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("span", { class: "fas fa-star" }, null, -1),
            _createTextVNode("Titulní fotka ", -1)
          ]))]))
        : _createCommentVNode("", true),
      (_ctx.selecting)
        ? (_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "checkbox",
            class: "form-check-input photo-tile-check shadow-sm",
            tabindex: "-1",
            checked: _ctx.selected,
            "aria-label": "Vybrat fotografii"
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.rotating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("span", {
              class: "spinner-border text-primary",
              role: "status"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.canDescribe)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
              placeholder: "Přidat popisek",
              "aria-label": "Popisek fotografie",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('describe', _ctx.description.trim()))),
              onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (($event.target as HTMLInputElement).blur()), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.description]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "fas fa-pencil-alt photo-tile-description-icon" }, null, -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", {
          class: _normalizeClass(["small me-auto", _ctx.descriptionStateClass])
        }, _toDisplayString(_ctx.descriptionStateText), 3),
        (_ctx.canRotate)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-link text-secondary px-1",
                title: "Otočit doleva",
                disabled: _ctx.rotating,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('rotate', 90)))
              }, [...(_cache[14] || (_cache[14] = [
                _createElementVNode("span", { class: "fas fa-undo" }, null, -1)
              ]))], 8, _hoisted_9),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-link text-secondary px-1",
                title: "Otočit doprava",
                disabled: _ctx.rotating,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('rotate', -90)))
              }, [...(_cache[15] || (_cache[15] = [
                _createElementVNode("span", { class: "fas fa-redo" }, null, -1)
              ]))], 8, _hoisted_10)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _cache[22] || (_cache[22] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-link text-secondary px-2",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false",
            title: "Další akce"
          }, [
            _createElementVNode("span", { class: "fas fa-ellipsis-h" })
          ], -1)),
          _createElementVNode("ul", _hoisted_12, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "dropdown-item",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('open')))
              }, [...(_cache[16] || (_cache[16] = [
                _createElementVNode("span", { class: "fas fa-search-plus fa-fw me-2" }, null, -1),
                _createTextVNode("Zvětšit ", -1)
              ]))])
            ]),
            (_ctx.canMove)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (! _ctx.isTitle)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "dropdown-item",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('make-title')))
                        }, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("span", { class: "fas fa-star fa-fw me-2" }, null, -1),
                          _createTextVNode("Nastavit jako titulní ", -1)
                        ]))])
                      ]))
                    : _createCommentVNode("", true),
                  (! _ctx.isTitle)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "dropdown-item",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('move', -1)))
                        }, [...(_cache[18] || (_cache[18] = [
                          _createElementVNode("span", { class: "fas fa-arrow-left fa-fw me-2" }, null, -1),
                          _createTextVNode("Posunout dopředu ", -1)
                        ]))])
                      ]))
                    : _createCommentVNode("", true),
                  (! _ctx.isLast)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "dropdown-item",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('move', 1)))
                        }, [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("span", { class: "fas fa-arrow-right fa-fw me-2" }, null, -1),
                          _createTextVNode("Posunout dozadu ", -1)
                        ]))])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.canRemove)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[21] || (_cache[21] = _createElementVNode("li", null, [
                    _createElementVNode("hr", { class: "dropdown-divider" })
                  ], -1)),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dropdown-item text-danger",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('remove')))
                    }, [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("span", { class: "fas fa-trash fa-fw me-2" }, null, -1),
                      _createTextVNode("Smazat ", -1)
                    ]))])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 2))
}